// Components==============
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { motion } from 'framer-motion';
import React, { useContext, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { contactTextValues } from 'utilities/contactTextValues';
import { GlobalContext } from 'utilities/GlobalContextWrapper';
import { useOpenUrlModal } from 'utilities/useOpenUrlModal';
import Modal from '../Modal';
import RichText from '../RichText';
import './index.module.scss';
// =========================

const framerButton = {
    hover: {
        x: 5,
    },
    tap: {
        x: 0,
    },
};

const ConditionalLink = ({ to, children }) => {
    if (to.includes('http'))
        return (
            <a href={to} styleName="wrapper" target="_blank" rel="noreferrer">
                {children}
            </a>
        );

    return (
        <NavLink to={`/${to}`} styleName="wrapper">
            {children}
        </NavLink>
    );
};

const Link = ({ text, to }) => (
    <motion.div variants={framerButton} whileHover="hover" whileTap="tap">
        <ConditionalLink to={to}>
            <span>{text}</span>
            <FontAwesomeIcon icon={faArrowRight} />
        </ConditionalLink>
    </motion.div>
);

const Popup = ({ popup, text }) => {
    const slug = `button-popup/${text}`;
    const openModal = useOpenUrlModal(slug);

    return (
        <>
            <motion.button
                styleName="wrapper"
                type="button"
                variants={framerButton}
                whileHover="hover"
                whileTap="tap"
                onClick={() => openModal()}
            >
                <span>{text}</span>
                <FontAwesomeIcon icon={faArrowRight} />
            </motion.button>
            <Modal slug={slug}>
                <div styleName="popup-wrapper">
                    <RichText richText={popup} />
                </div>
            </Modal>
        </>
    );
};

const File = ({ file, text }) => (
    <motion.a
        href={`/storage/${file}`}
        download
        styleName="wrapper"
        type="button"
        variants={framerButton}
        whileHover="hover"
        whileTap="tap"
    >
        <span>{text}</span>
        <FontAwesomeIcon icon={faArrowRight} />
    </motion.a>
);

const CustomModal = ({ text, type }) => {
    const { setContactText } = useContext(GlobalContext);

    const { pathname } = useLocation();

    const openContactModal = useOpenUrlModal('contact-popup');
    const openInterviewModal = useOpenUrlModal('open-sollicitatie-popup');

    function handleClick() {
        if (type === 'contact') {
            if (pathname.includes('stage'))
                setContactText(contactTextValues.internship);
            else setContactText(contactTextValues.contact);
            return openContactModal();
        }
        if (type === 'job_application') return openInterviewModal();
    }

    return (
        <motion.button
            styleName="wrapper"
            type="button"
            variants={framerButton}
            whileHover="hover"
            whileTap="tap"
            onClick={handleClick}
        >
            <span>{text}</span>
            <FontAwesomeIcon icon={faArrowRight} />
        </motion.button>
    );
};

export default function ArrowButton({ text, type, to, file, popup }) {
    if (type === 'popup') return <Popup popup={popup} text={text} />;

    if (type === 'file') return <File file={file} text={text} />;

    if (type === 'contact' || type === 'job_application')
        return <CustomModal text={text} type={type} />;

    return <Link to={to} text={text} />;
}
